import { DataFetchingClient } from 'data-fetching-client';

import { mutationFieldPolicies, queryFieldPolicies } from './fieldPolicies';

export const getDefaultDataFetchingClient = () => {
  return new DataFetchingClient({
    mutationFieldPolicies,
    queryFieldPolicies,
  });
};
